import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { map } from 'lodash-es';

import Photo from 'app/models/photo';

import * as PhotoSwipe from "photoswipe";
import * as PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

@Component({
  selector: 'full-screen-carousel',
  templateUrl: './full-screen-carousel.component.html'
})
export class FullScreenCarouselComponent implements OnInit {
  galleryKey: string = 'galleryKey';
  @Input() photos: Photo[];
  @Input() clickedIndex: number;
  @ViewChild('photoSwipe', { static: true }) photoSwipe: ElementRef;
  @Output('onClose') onClose = new EventEmitter();


  constructor() { }

  ngOnInit() {
    const images = map(this.photos, (photo: Photo) => {
      return {
        src: photo.original_url,
        w: photo.width,
        h: photo.height,
        alt: ''
      }
    });

    const gallery = new PhotoSwipe(this.photoSwipe.nativeElement, PhotoSwipeUI_Default, images, { index: this.clickedIndex });
    gallery.init();

    gallery.listen('destroy', () => {
      this.onClose.emit()
    })
  }
}
